module.exports = __webpack_public_path__ + "img/product_img.38a25b98.jpg";